import { useQuery } from '@tanstack/react-query';
import ky from 'ky';
import { useTranslation } from 'react-i18next';

import config from '../../config/app';

const useOpeningHoursQuery = () => {
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage || config.defaultLanguage;

    return useQuery({
        queryKey: ['openingHours', lang],
        queryFn: (): Promise<OpeningHours> => {
            return ky
                .get(`https://muo.cz/wp-json/muo/v1/branch/openHours`)
                .json<OpeningHours>();
        },
    });
};

export default useOpeningHoursQuery;
